export function timelineScroll() {
    var items = document.querySelectorAll('.timeline li');
    var timelineHeight = document.querySelector('.timeline ul').offsetHeight;
    var greyLine = document.querySelector('.default-line');
    var lineToDraw = document.querySelector('.draw-line');

    // Sets the height that the greyLine (.default-line) should be according to `.timeline ul` height
    greyLine.style.height = timelineHeight + 'px';

  
    // Run this function only if draw line exists on the page
    if (lineToDraw) {
      window.addEventListener('scroll', function() {
        // Need to constantly get '.draw-line' height to compare against '.default-line'

        var greyLineHeight = greyLine.offsetHeight;
        var windowDistance = window.pageYOffset || document.documentElement.scrollTop;
        var windowHeight = window.innerHeight / 2;
        var timelineDistance = document.querySelector('.timeline').offsetTop;
  
        if (windowDistance >= timelineDistance - windowHeight) {
          var line = windowDistance - timelineDistance + windowHeight;
  
          if (line <= greyLineHeight) {
            lineToDraw.style.height = line + 'px';
          } 
        } else {
            lineToDraw.style.height = greyLineHeight
          }
  
        // This takes care of adding the class in-view to the li:before items
        var bottom = lineToDraw.offsetTop + lineToDraw.offsetHeight;
        items.forEach(function(item) {
          var circlePosition = item.offsetTop;
  
          if (bottom > circlePosition) {
            item.classList.add('in-view');
          } else {
            item.classList.remove('in-view');
          }
        });
      });
    }
  }